import { React, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Autocomplete, CardContent, TextField, Grid, Typography, Button } from '@mui/material';
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

const Projkeyform = ({ projkeyData, getOrganizations, saveProjkey }) => {
  Projkeyform.propTypes = {
    saveProjkey: PropTypes.func.isRequired,
    getOrganizations: PropTypes.func.isRequired,
    projkeyData: PropTypes.object,
  };

  const [organizations, setOrganizations] = useState([]);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    organizationId: 0,  // Add the organizationId for the selection
  });

  useEffect(() => {
    fetchOrganizations();
    if (projkeyData) {
      setFormData({
        id: projkeyData.id ?? '',
        name: projkeyData.name ?? '',
        organizationId: projkeyData.organizationId ?? '',  // Default to projkeyData organizationId
      });
    } else {
      setFormData({
        id: '',
        name: '',
        organizationId: 0,  // Default empty organizationId
      });
    }
    
  }, []);

  const fetchOrganizations = async () => {
    try {
      const response = await getOrganizations();
      setOrganizations(response.data.resp); // Assuming response data structure
    } catch (error) {
      console.error("Error fetching organizations:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    saveProjkey(formData);
  };

  const handleSelection = (event, newValue) => {
    setFormData({ ...formData, organizationId: newValue ? newValue.id : 0 });
  };

  const handleReset = () => {
    setFormData({
      id: '',
      name: '',
      organizationId: '',  // Reset the organizationId as well
    });
  };

  return (
    <MDBox
      container
      sx={{
        minHeight: "75vh",
        p: 0,
      }}
    >
      <MDBox
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" component="h1" align="center" gutterBottom>
          Organization Form
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Project Name"
                name="name"
                variant="outlined"
                required
                value={formData.name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={organizations} // Use the organizations fetched from the API
                getOptionLabel={(option) => option.name} // Assuming each organization has a 'name' field
                onChange={handleSelection}
                value={organizations.find(org => org.id === formData.organizationId) || null}
                renderInput={(params) => (
                  <TextField {...params} label="Search Organizations" variant="outlined" fullWidth />
                )}
                // isOptionEqualToValue={(option, value) => option.id === value.id} // Assuming each organization has an 'id'
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="space-between">
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                onClick={handleReset} // Reset form on button click
              >
                Reset
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </MDBox>
  );
};

export default Projkeyform;
